import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { styled } from '@mui/material/styles';

export const HistoryTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 1.5,
  border: `1px solid ${theme.palette.grey[200]}`,
  overflowX: 'auto',
}));

/** `headerBackground` is the white-label table header color; header text and dividers take its contrast color. */
export const HistoryTable = styled(Table, {
  shouldForwardProp: prop => prop !== 'headerBackground',
})<{ headerBackground?: string }>(({ theme, headerBackground }) => {
  const headerText = theme.palette.getContrastText(headerBackground || theme.palette.common.white);
  return {
    '& .MuiTableCell-root': { fontSize: '12px' },
    '& .MuiTableCell-head': { color: headerText, fontWeight: theme.typography.fontWeightMedium },
    '& .MuiTableCell-head:not(:last-of-type)': {
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        right: 0,
        top: '25%',
        height: '50%',
        borderRight: `1px solid ${headerText}`,
        opacity: 0.6,
      },
    },
    '& .MuiTableSortLabel-root, & .MuiTableSortLabel-root.Mui-active, & .MuiTableSortLabel-icon': {
      color: `${headerText} !important`,
    },
    '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(even)': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },
    '& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root': {
      borderBottom: 0,
    },
  };
});

export const ChangeCell = styled(TableCell, {
  shouldForwardProp: prop => prop !== 'negative',
})<{ negative: boolean }>(({ theme, negative }) => ({
  color: negative ? theme.palette.error.main : theme.palette.success.main,
}));
